<template>
    <el-dialog :title="title" :visible.sync="showModal" :close-on-click-modal="false" :destroy-on-close="true"
        width="750px">
        <el-form ref="form" :rules="rules" :model="form" label-position="left" label-width="90px">
            <el-form-item label="图片" prop="cover_url">
                <upload-one v-model="form.cover_url" width="100%" height="250px"></upload-one>
                <p style="margin: 0; line-height: 1.5rem;">(380*165倍数)</p>
            </el-form-item>

            <el-form-item label="跳转类型" prop="link_type">
                <el-select v-model="form.link_type" @change="getNavigationType">
                    <el-option label="活动" :value="1" />
                    <el-option label="测评体验" :value="2" />
                    <el-option label="公众号文章" :value="3" />
                    <el-option label="平台内文章" :value="4" />
                    <el-option label="无跳转" :value="5" />
                </el-select>
            </el-form-item>

            <el-form-item v-if="form.link_type === 1" label="活动" prop="link_to">
                <el-select v-loading="activityLoading" no-match-text="请重新选择" v-model="form.link_to" filterable>
                    <el-option v-for="(type, tIndex) in activityList" :key="tIndex" :label="type.title" :value="type.id" />
                </el-select>
            </el-form-item>

            <el-form-item v-if="form.link_type === 2" label="测评体验" prop="link_to">
                <el-select v-loading="activityLoading" no-match-text="请重新选择" v-model="form.link_to" filterable>
                    <el-option v-for="(type, tIndex) in activityList" :key="tIndex" :label="type.name" :value="type.id" />
                </el-select>
            </el-form-item>

            <el-form-item v-if="form.link_type === 3" label="跳转链接" prop="link_to">
                <el-input v-model="form.link_to" />
            </el-form-item>

            <el-form-item v-if="form.link_type === 4" label="平台文章" prop="link_to">
                <el-select v-loading="activityLoading" no-match-text="请重新选择" v-model="form.link_to" filterable>
                    <el-option v-for="(type, tIndex) in activityList" :key="tIndex" :label="type.title" :value="type.id" />
                </el-select>
            </el-form-item>

            <el-form-item label="权重" prop="weight">
                <el-input-number v-model="form.weight" :min="1" :max="9999"></el-input-number>
            </el-form-item>

            <el-form-item label="描述" prop="description">
                <el-input type="textarea" :rows="4" v-model="form.description" />
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="trunOff">取消</el-button>
            <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { banner } from "@/api/operation"

export default {
    data: () => ({
        rules: {
            cover_url: [{ required: true, message: "图片不能为空", trigger: "blur" }],
            link_type: [{ required: true, message: "请选择跳转类型", trigger: "blur" }],
            link_to: [{ required: true, message: "请输入跳转路径", trigger: "blur" }],
            weight: [{ type: "number", required: true, message: "请输入权重", trigger: "blur" }],
            description: [{ required: false, message: "请输入描述文字", trigger: "blur" }]
        },
        form: {
            id: null,
            category_id: 3,
            cover_url: null,
            link_type: null,
            link_to: '',
            weight: '',
            description: ''
        },
        activityLoading: false,
        activityList: [],
        btnLoading: false
    }),
    props: {
        // 展示
        show: {
            default: false,
            type: Boolean
        },
        // 模式
        type: {
            default: 'add',
            type: String
        },
        // 编辑的数据
        editData: null | Object
    },
    methods: {
        trunOff() {
            this.showModal = false
        },
        handleUpdateFormModelByModalType() {
            const handlers = {
                add: () => {
                    this.form = {
                        id: null,
                        category_id: 3,
                        cover_url: null,
                        link_type: null,
                        link_to: '',
                        weight: '',
                        description: ''
                    }
                },
                edit: () => {
                    const { id, cover_url, link_type, link_to, weight, description } = this.editData
                    this.form = {
                        id,
                        category_id: 3,
                        cover_url,
                        link_type,
                        link_to: [3, 5].includes(Number(link_type)) ? link_to : Number(link_to),
                        weight,
                        description
                    }
                    this.getNavigationType(link_type, link_to, true)
                }
            }

            handlers[this.type]()
        },
        async getNavigationType(link_type, link_to, noClear = false) {
            if (!noClear) this.form.link_to = ''
            if (link_type === 3 || link_type === 5) return

            this.activityLoading = true

            const { data } = await banner.navigationType(link_type, link_to)

            this.activityList = data

            this.activityLoading = false
        },
        saveData() {
            this.$refs["form"].validate(async (valid) => {
                if (valid) {
                    this.btnLoading = true;
                    try {
                        await banner.createBanner(this.form)
                        this.$notify({
                            title: "成功",
                            message: "保存成功",
                            type: "success",
                            duration: 2000
                        });
                        this.$emit("onUpdate")
                        this.trunOff()
                    } catch {
                        this.$message.error('出错了!');
                    } finally {
                        this.btnLoading = false;
                    }
                }
            });
        },
    },
    computed: {
        showModal: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('update:show', val);
            }
        },
        title() {
            const { type } = this

            const title = {
                add: "新建数据",
                edit: "编辑数据"
            }

            return title[type]
        }
    },
    watch: {
        show(newVal) {
            if (newVal) {
                this.handleUpdateFormModelByModalType()
            }
        }
    }
}
</script>

<style lang="scss" scoped></style>